const countryAndAreaOptions = new Map(
    [['CNPATENT', {name: '中国',imgNo: '01'}],
    ['FMZL', { name: '中国发明公开', imgNo: '01' }], 
    ['SYXX', { name: '中国实用新型', imgNo: '01' }], 
    ['WGZL', { name: '中国外观设计', imgNo: '01' }], 
    ['FMSQ', { name: '中国发明授权', imgNo: '01' }], 
    ['TWPATENT', {name: '台湾省', imgNo: '01'}], 
    ['HKPATENT', {name: '香港特区', imgNo: '01'}], 
    ['MODESIGN', { name: '澳门特区', imgNo: '01' }], 
    ['USPATENT', {name: '美国',imgNo: '02'}], 
    ['USDESIGN', { name: '美国外观', imgNo: '02' }], 
    ['JPPATENT', {name: '日本', imgNo: '03'}], 
    ['JPDESIGN', {name: '日本外观', imgNo: '03' }], 
    ['KRPATENT', {name: '韩国', imgNo: '10'}], 
    ['KRDESIGN', {name: '韩国外观', imgNo: '10'}], 
    ['EPPATENT', {name: 'EPO', imgNo: '08'}], 
    ['WOPATENT', {name: 'WIPO', imgNo: '09'}], 
    ['WODESIGN', { name: 'WIPO外观', imgNo: '09'}], 
    ['DEPATENT', {name: '德国', imgNo: '05'}], 
    ['DEDESIGN', { name: '德国外观', imgNo: '05' }], 
    ['GBPATENT', {name: '英国', imgNo: '04'}], 
    ['FRPATENT', {name: '法国', imgNo: '06'}], 
    ['FRDESIGN', { name: '法国外观', imgNo: '06' }], 
    ['CHPATENT', {name: '瑞士', imgNo: '07'}], 
    ['RUPATENT', {name: '俄罗斯', imgNo: '11'}], 
    ['RUDESIGN', { name: '俄罗斯外观', imgNo: '11' }], 
    ['ASPATENT', {name: '东南亚', imgNo: '12'}], 
    ['GCPATENT', {name: '阿拉伯', imgNo: '13'}], 
    ['AUPATENT', {name: '澳大利亚', imgNo: '14'}], 
    ['CAPATENT', {name: '加拿大', imgNo: '15'}], 
    ['ESPATENT', {name: '西班牙', imgNo: '16'}], 
    ['ATPATENT', {name: '奥地利', imgNo: '17'}], 
    ['ITPATENT', {name: '意大利', imgNo: '18'}], 
    ['APPATENT', {name: '非洲地区', imgNo: '19'}], 
    ['SEPATENT', {name: '瑞典', imgNo: '20'}], 
    ['OTHERPATENT', {name: '其他国家地区' + ''}]])
export default countryAndAreaOptions
